module.exports = __webpack_public_path__ + "img/banner_3.89398712.jpg";